


let estilos = {
    1: "0.5vw solid rgb(201, 0, 0)",        //Rojo
    2: "0.5vw solid rgb(171, 201, 0)",      //Amarillo oscuro
    3: "0.5vw solid rgb(18, 155, 0)",       //Verde oscuro
    4: "0.5vw solid rgb(107, 231, 91)",     //Verde claro
    5: "0.5vw solid rgb(30, 255, 0)",       //Verde mas claro
    6: "0.5vw solid rgb(255, 166, 0)",      //Naranja claro
    7: "0.5vw solid rgb(216, 115, 0)",      //Naranja mas oscuro
    8: "0.5vw solid rgb(255, 47, 47)",      //Rojo mas claro
    9: "0.5vw solid rgb(255, 234, 47)",     //Amarillo claro
    10: "0.5vw solid rgb(217, 255, 0)",     //Amarillo limon
    11: "0.5vw solid rgb(145, 255, 0)",     //Amarillo verdoso
    12: "0.5vw solid rgb(0, 255, 149)",     //Cian claro
    13: "0.5vw solid rgb(0, 158, 92)",      //Cian oscuro
    14: "0.5vw solid rgb(0, 247, 255)",     //Azul celeste
    15: "0.5vw solid rgb(0, 125, 134)",     //Azul grisoso
    16: "0.5vw solid rgb(0, 102, 255)",     //Azul claro
    17: "0.5vw solid rgb(0, 50, 126)",      //Azul oscuro
    18: "0.5vw solid rgb(132, 0, 255)",     //Azul moradusco
    19: "0.5vw solid rgb(174, 0, 255)",     //Morado tipo fucsia
    20: "0.5vw solid rgb(225, 0, 255)",     //Fucsia
    21: "0.5vw solid rgb(255, 0, 170)",     //Rosa
    22: "0.5vw solid rgb(139, 0, 105)",     //Rosa oscuro
    23: "0.5vw solid rgb(92, 69, 146)",     //Morado
    24: "0.5vw solid rgb(241, 136, 255)",   //Rosa claro
    25: "0.5vw solid rgb(136, 255, 190)",   //Verde Limon claro
    26: "0.5vw solid rgb(255, 164, 136)",   //Rojo salmon
    27: "0.5vw solid rgb(247, 255, 136);",  //amarillo muy claro
    28: "0.5vw solid rgbrgb(160, 160, 160)",//Gris
    29: "0.5vw solid rgb(153, 69, 69)",     //Marron
    30: "0.5vw solid rgb(92, 69, 146)"      //Azul morado mas oscuro
}

let estilos2 = {
    1: "rgb(201, 0, 0)",        //Rojo
    2: "rgb(171, 201, 0)",      //Amarillo oscuro
    3: "rgb(18, 155, 0)",       //Verde oscuro
    4: "rgb(107, 231, 91)",     //Verde claro
    5: "rgb(30, 255, 0)",       //Verde mas claro
    6: "rgb(255, 166, 0)",      //Naranja claro
    7: "rgb(216, 115, 0)",      //Naranja mas oscuro
    8: "rgb(255, 47, 47)",      //Rojo mas claro
    9: "rgb(255, 234, 47)",     //Amarillo claro
    10: "rgb(217, 255, 0)",     //Amarillo limon
    11: "rgb(145, 255, 0)",     //Amarillo verdoso
    12: "rgb(0, 255, 149)",     //Cian claro
    13: "rgb(0, 158, 92)",      //Cian oscuro
    14: "rgb(0, 247, 255)",     //Azul celeste
    15: "rgb(0, 125, 134)",     //Azul grisoso
    16: "rgb(0, 102, 255)",     //Azul claro
    17: "rgb(0, 50, 126)",      //Azul oscuro
    18: "rgb(132, 0, 255)",     //Azul moradusco
    19: "rgb(174, 0, 255)",     //Morado tipo fucsia
    20: "rgb(225, 0, 255)",     //Fucsia
    21: "rgb(255, 0, 170)",     //Rosa
    22: "rgb(139, 0, 105)",     //Rosa oscuro
    23: "rgb(92, 69, 146)",     //Morado
    24: "rgb(241, 136, 255)",   //Rosa claro
    25: "rgb(136, 255, 190)",   //Verde Limon claro
    26: "rgb(255, 164, 136)",   //Rojo salmon
    27: "rgb(247, 255, 136);",  //amarillo muy claro
    28: "rgbrgb(160, 160, 160)",//Gris
    29: "rgb(153, 69, 69)",     //Marron
    30: "rgb(92, 69, 146)"      //Azul morado mas oscuro
}

export { estilos, estilos2 }